declare global {
  interface Window {
    opr?: { addons: unknown }
    opera?: unknown
    InstallTrigger?: unknown
    HTMLElement?: any
    safari?: { pushNotification: unknown }
    chrome?: { webstore: unknown; runtime: unknown }
    StyleMedia?: unknown
  }
}
// These native APIs do not have typescript definitions and do not exist on all browsers:
function detectBrowser() {
  // Opera 8.0+
  const isOpera =
    (!!window.opr && !!window.opr.addons) ||
    !!window.opera ||
    navigator.userAgent.indexOf(' OPR/') >= 0
  if (isOpera) return 'Opera'

  // Firefox 1.0+
  const isFirefox = typeof window.InstallTrigger !== 'undefined'
  if (isFirefox) return 'Firefox'

  // Safari 3.0+
  const isSafari =
    /constructor/i.test(window.HTMLElement) ||
    (function (p: any) {
      return p.toString() === '[object SafariRemoteNotification]'
    })(
      !window['safari'] ||
        (typeof window.safari !== 'undefined' &&
          window['safari'].pushNotification)
    )
  if (isSafari) return 'Safari'

  // Edge 20+
  const isEdge = !!window.StyleMedia
  if (isEdge) return 'Edge'

  // Chrome 1 - 79
  const isChrome =
    !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)
  if (isChrome) return 'Chrome'

  // Edge (based on chromium) detection
  const EdgeChromium = isChrome && navigator.userAgent.indexOf('Edg') != -1
  if (EdgeChromium) return 'EdgeChromium'

  return 'Unknown'
}

export default detectBrowser
